export default "__VITE_ASSET__CMb6RYju__"